<div class="cmx-icon-information-rounded-fill {{customColor}}" [innerHTML]="(text | translate) | sanitizeHtml"></div>
